/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum LightlyTrainerPrecisionV2 {
    NUMBER_16 = 16,
    NUMBER_32 = 32
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const LightlyTrainerPrecisionV2ValidatorShape = [
    16,
    32
];
export const LightlyTrainerPrecisionV2Validator = yup.mixed().oneOf(LightlyTrainerPrecisionV2ValidatorShape);
export const LightlyTrainerPrecisionV2StringifyShapeProperties = {};
export const LightlyTrainerPrecisionV2StringifyShape: StringSchema = {
    title: 'LightlyTrainerPrecisionV2 Stringifier',
    type: 'string'
};
export const LightlyTrainerPrecisionV2Stringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(LightlyTrainerPrecisionV2StringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function LightlyTrainerPrecisionV2FromJSON(json: any): LightlyTrainerPrecisionV2 {
    return LightlyTrainerPrecisionV2FromJSONTyped(json, false);
}
export function LightlyTrainerPrecisionV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): LightlyTrainerPrecisionV2 {
    return json as LightlyTrainerPrecisionV2;
}
export function LightlyTrainerPrecisionV2ToJSON(value?: LightlyTrainerPrecisionV2 | null): any {
    return value as any;
}
